// extracted by mini-css-extract-plugin
module.exports = {"closed":"drawer_closed__3-C-z","open":"drawer_open__1joZ2"};